import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { AutoImage } from '../components/auto-image'
import { BannerImage } from '../components/banner-image'
import { BlogSection } from '../components/blog-section'
import { ContentContainer } from '../components/content-container'
import { DecoratedFrame } from '../components/decorated-frame'
import { HeadBannar } from '../components/head-bannar'
import { Section } from '../components/section'
import { DiagramContainer, DiagramItem, ItemTitle, ItemText } from '../components/section-diagram'
import { SectionNavigator } from '../components/section-navigator'
import { SectionSpaceLarge, SectionSpaceMedium } from '../components/section-space'
import { SectionTextExtraLarge, SectionTextMedium, SectionTextSmall } from '../components/section-text'
import { SectionTitle } from '../components/section-title'

const Outer = styled.div``

type GrapeSeedPageProps = {

}
export const GrapeSeedPage: FunctionComponent<GrapeSeedPageProps> = () => {
  return <Outer>
    <HeadBannar desktop={() => <BannerImage src="/images/header_04.jpg" />} mobile={() => <BannerImage src="/images/header_04_mobile.jpg" />}></HeadBannar>
    <ContentContainer>
      {/* <SectionNavigator labelMap={new Map([['about', 'About us']])} /> */}
      <Section id="about">
        <SectionTitle>About us</SectionTitle>
        <SectionSpaceMedium />
        <DecoratedFrame leftTop="/images/dec_04_01.png" rightBottom="/images/dec_04_02.png">
          <AutoImage src="/images/img_06.jpg" mobileSrc="/images/img_06_mobile.jpg" />
          <AutoImage src="/images/img_07.jpg" mobileSrc="/images/img_07_mobile.jpg" />
        </DecoratedFrame>
        <SectionSpaceMedium />
        <SectionTextSmall>
          真のグローバル社会到来に向けて、英語によるコミュニケーションの重要性が高まる時代だからこそ、<br />
          子ども達の知識欲を大事に育てたいと考えています。<br />
          室の木幼稚園では年中組から週3日以上実施する英語クラスが選択出来るようになっています。<br />
          英語力を養うことで主体的で意欲的な成長がみられるようになります。<br />
          これを卒園後も継続出来るように、当園では小学生クラスを設けています。<br />
          英語脳が発達し、自分の考え方や気持ちを伝えられるコミュニケーションスキルが身に着くと、<br />
          自己肯定感も高まり、国際社会で活躍出来る力を養うことが出来ると考えています。
        </SectionTextSmall>
        <SectionSpaceLarge />
      </Section>
      <BlogSection where={{categoryName: 'grape-seed'}}/>
    </ContentContainer>
  </Outer>
}